import html2pdf from "html2pdf.js";
import html2canvas from "html2canvas";
import employeeLogo from "../../images/employee.png";
import moment from "moment";

  export const InvoiceNewPrinted = async ({ state, ledger = "" }) => {
console.log("invoice", state.invoice)
  let temp = localStorage.getItem("template");
  let companyCode = localStorage.getItem("companyCode");
  let baseUrl = localStorage.getItem("base_url");
  let imgSrc = baseUrl ? baseUrl : employeeLogo;
  let user = localStorage.getItem("username") || localStorage.getItem("token");
  let company = localStorage.getItem("company");
  let address = localStorage.getItem("address");
  let street = localStorage.getItem("street");
  let phone1 = localStorage.getItem("p1");
  let phone2 = localStorage.getItem("p2");
  let phone = localStorage.getItem("phone");
  let terms = localStorage.getItem("terms") || "";
  terms = terms.replace(/(\d+[\.\-])\s+/g, "\n$1 ");

  const rows = state.items
    .map(
      (item, i) => `
    <tr style="height: 25px;">
      <td style="border: 1px solid #000; text-align: center; padding: 8px;">${
        i + 1
      }</td>
      <td style="border: 1px solid #000; text-align: center; padding: 8px;">${
        item?.name
      }</td>
      <td style="border: 1px solid #000; text-align: center; padding: 8px;">${
        item?.saleQuantity || 0
      }</td>
      <td style="border: 1px solid #000; text-align: center; padding: 8px;">${
        item?.price % 1 === 0 ? item?.price || 0 : item?.price.toFixed(3)
      }</td>
      <td style="border: 1px solid #000; text-align: center; padding: 8px;">${
        item.saleQuantity
          ? item.saleQuantity * parseInt(item.price)
          : item.price || 0
      }</td>
    </tr>
  `
    )
    .join("");

  const template = `
    <div style="font-family: Arial, sans-serif; padding: 20px; background-color: white;">
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <div style="flex: 1;">
          <img src="${imgSrc}" alt="Brand Logo" style="width: 70px; height: 70px;" />
          <h2 style="margin: 0; font-size: 20px; font-weight: bold;">${company}</h2>
        </div>
    <div style="text-align: right;">
  <div style="color: #000; padding: 10px; display: inline-block; border-radius: 5px;">
    <h3 style="margin: 0; font-size: 18px;">INVOICE</h3>
  </div>
</div>

      </div>
      <div style="margin-top: 20px; display: flex; justify-content: space-between;">
        <div style="flex: 1;">
          <p style="margin: 0; font-size: 14px; font-weight: bold;">Invoice to:</p>
          <p style="margin: 0; font-size: 12px;">${
            state?.ledger?.name || state?.ledger || ""
          }</p>
          <p style="margin: 0; font-size: 12px;">${
            ledger?.new_ledger?.address || ""
          }</p>
        </div>
        <div style="flex: 1; text-align: right;">
          <p style="margin: 0; font-size: 12px;"><strong>Invoice #</strong> ${
            state?.invoiceNumber || ""
          }</p>
           <p style="margin: 0; font-size: 12px;"><strong>Date</strong> ${
           moment(state?.invoiceDate, "DD-MM-YYYY").format("DD-MM-YYYY")
          }</p>
        </div>
      </div>
      <div id="invoice" style="max-width: 800px; margin: auto; padding: 20px;">
        <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
          <thead>
            <tr>
              <th style="border: 1px solid #000; text-align: center; padding: 8px; background-color: #333; color: #fff;">No</th>
              <th style="border: 1px solid #000; text-align: center; padding: 8px; background-color: #333; color: #fff;">Item</th>
              <th style="border: 1px solid #000; text-align: center; padding: 8px; background-color: #333; color: #fff;">Qty</th>
              <th style="border: 1px solid #000; text-align: center; padding: 8px; background-color: #333; color: #fff;">Price</th>
              <th style="border: 1px solid #000; text-align: center; padding: 8px; background-color: #333; color: #fff;">Total</th>
            </tr>
          </thead>
          <tbody>${rows}</tbody>
        </table>
        <!-- Footer and other sections go here -->

       <div style="float: right; width: 50%;">
  <table style="width: 100%; border-collapse: collapse;">
    <tr>
      <th style="text-align: left; padding: 8px;">Balance</th>
      <td style="text-align: right; padding: 8px;">
        ${state?.ledger?.saleTotal || state?.ledger?.purchaseTotal || 0}
      </td>
    </tr>
    <tr>
      <th style="text-align: left; padding: 8px;">Received</th>
      <td style="text-align: right; padding: 8px;">
        ${state?.recieved || 0}
      </td>
    </tr>
    <tr>
      <th style="text-align: left; padding: 8px; font-weight: bold;">Total</th>
      <td style="text-align: right; padding: 8px; font-weight: bold;">
        ${
          Number(state?.total || 0) % 1 === 0
            ? `${state?.total || 0}`
            : `${Number(state?.total).toFixed(3)}`
        }
      </td>
    </tr>
    <tr>
      <th style="text-align: left; padding: 8px; font-weight: bold;">Remaining</th>
      <td style="text-align: right; padding: 8px; font-weight: bold;">
        ${
          Number(state?.total - state?.recieved || 0) % 1 === 0
            ? `${state?.total - state?.recieved || 0}`
            : `${Number(state?.total - state?.recieved || 0).toFixed(3)}`
        }
      </td>
    </tr>
  </table>
</div>



<div style="display: flex; justify-content: space-between; margin-top: 205px;">
  <div style="margin-top: 20px; display: flex; gap: 10px;">
    <p style="margin: 0; line-height: 1.8;">📞 Phone<br />📍 Address</p>
    <p style="margin: 0; line-height: 1.8;">
      ${phone}<br />${address}
    </p>
  </div>

  <div style="margin-top: 60px;">
    <span
      style="
        border-top: 1px solid #000;
        padding-top: 5px;
        display: inline-block;
      "
    >
      Authorized Sign
    </span>
  </div>
</div>

     <div style="display: flex; justify-content: center;margin-top:50px">
            <p style={{ margin: 0, lineHeight: 1.8 }}>${state.description}</p>
        </div>

      </div>
    </div>
  `;
  const element = document.createElement("div");
  element.innerHTML = template; // Populate the element with HTML template
  document.body.appendChild(element); // Optional: Append to the DOM for debugging
  
  let opt = {
    margin: 0,
    filename: "invoice.pdf",
    image: { type: "jpeg", quality: 0.98 },
    html2canvas: {
      scale: 2,
      useCORS: true, // Enable cross-origin resource sharing
    },
    jsPDF: { unit: "mm", format: "a4", orientation: "portrait" }, // A4 size in portrait
  };
  
  try {
    const blob = await html2pdf().from(element).set(opt).output("blob");
    const url = URL.createObjectURL(blob);
    const newWindow = window.open(url, "_blank");
    if (newWindow) {
      newWindow.onload = () => {
        setTimeout(() => {
          newWindow.print();
        }, 1000); // Wait for the document to load before printing
      };
    } else {
      alert("Please allow popups for this website");
    }
  } catch (error) {
    console.error("Error generating PDF:", error);
  }
  
  // html2pdf()
  //   .from(element)
  //   .set(opt)
  //   .output("blob")
  //   .then((blob) => {
  //     const url = URL.createObjectURL(blob);
  //     const newWindow = window.open(url, "_blank");
  //     if (newWindow) {
  //       newWindow.onload = function () {
  //         setTimeout(() => {
  //           newWindow.print();
  //         }, 1000); // Wait a second for the PDF to load before printing
  //       };
  //     } else {
  //       alert("Please allow popups for this website");
  //     }
  //   });
};





